module.exports = __webpack_public_path__ + "static/img/obj.38ed40d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone/page/obj.png
// module id = ygL/
// module chunks = 1